import styled from "styled-components";

export default styled.div`
  margin-top: 20px;
  padding-top: 15px;
  .lp-tags {
    font-weight: 300;
    line-height: 24px;
    ul {
      display: flex;
      flex-wrap: wrap;
    }

    a {
      li {
        color: #000;
        background: #d8d8d8;
        padding: 0 10px 5px;
        transition: all 0.6s ease 0s;
        margin-right: 5px;
        margin-bottom: 10px;
        border-radius: 5px;
      }
      &:hover li {
        background: ${(props) => props.theme.colors.primary.main}
        color: #fff;
      }
    }
  }

  .chip-tag {
    margin-right: 5px;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 991px) {
    .lp-tags {
      a {
        font-size: 11px;
      }
    }
  }
`;
